import { render, staticRenderFns } from "./View_Home.vue?vue&type=template&id=48891f5f&scoped=true&"
import script from "./View_Home.vue?vue&type=script&lang=js&"
export * from "./View_Home.vue?vue&type=script&lang=js&"
import style0 from "./View_Home.vue?vue&type=style&index=0&id=48891f5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48891f5f",
  null
  
)

export default component.exports